import { computeAxisPercentPoints } from './computeAxisPercentPoints';
import type {
  IAxisPercentSeriesItem,
  IBuildAxisPercentBarOptions,
  TAxisChartSeriesInput,
} from './types';

/**
 * 堆叠柱占比系列：ECharts value 恒为占比字符串，空原始值 → "0.00"。
 */
export function buildAxisPercentBarSeries(
  seriesData: TAxisChartSeriesInput[] | undefined,
  xAxisData: string[] | undefined,
  options?: IBuildAxisPercentBarOptions,
): IAxisPercentSeriesItem[] {
  const { stackId = 'total' } = options ?? {};
  const baseSeries = computeAxisPercentPoints(seriesData, xAxisData);

  return baseSeries.map(seriesItem => ({
    ...seriesItem,
    type: 'bar',
    stack: stackId,
    data: seriesItem.data.map(point => ({
      ...point,
      value: point.oPercent.toFixed(2),
    })),
  }));
}
